import type { VatCheckLevel } from '@kassa/shared';

// ƏDV yoxlaması nişanı (KT-69, edv-qaydalari 2.9): rəng tək deyil — yanında söz və işarə (rəng korluğu).
const LEVEL: Record<VatCheckLevel, { cls: string; mark: string; word: string }> = {
  green: { cls: 'badge-ok', mark: '✓', word: 'Uyğun' },
  red: { cls: 'badge-bad', mark: '✕', word: 'Uyğun deyil' },
  yellow: { cls: 'badge-warn', mark: '!', word: 'Yoxlayın' },
  grey: { cls: 'badge-off', mark: '–', word: 'Yoxlanmadı' },
  blue: { cls: 'badge-info', mark: 'i', word: 'Təsdiqlənib' },
};

export const VAT_CHECK_WORD: Record<VatCheckLevel, string> = Object.fromEntries(Object.entries(LEVEL).map(([k, v]) => [k, v.word])) as Record<VatCheckLevel, string>;

export function VatCheckBadge({ level, title }: { level: VatCheckLevel; title?: string }) {
  const l = LEVEL[level];
  return (
    <span className={`badge ${l.cls}`} title={title}>
      <span aria-hidden="true">{l.mark}&nbsp;</span>
      {l.word}
    </span>
  );
}

/** XİF MN kodu: 10 rəqəm «0000 00 000 0» qrupları ilə; natamam kod olduğu kimi. */
export function formatHs(code: string): string {
  return code.length === 10 ? `${code.slice(0, 4)} ${code.slice(4, 6)} ${code.slice(6, 9)} ${code.slice(9)}` : code;
}
